import { COPY } from '../../constants/copy'
import { isTvMode } from '../../utils/tvMode'
import './SkipHint.css'

/**
 * TV-only "OK ▸ skip" nudge. Fades in after 1.5 s so it never competes
 * with the line it is offering to skip.
 */
export const SkipHint = () => {
  if (!isTvMode()) return null
  return (
    <div className="skipHint" aria-hidden="true">
      {COPY.SKIP_HINT}
    </div>
  )
}
